"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepConsents = void 0;
var React = require("react");
var Consents_1 = require("components/Consents");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var StepConsents = function (props) {
    var _a = React.useState(false), acceptedTermsAndConditions = _a[0], setAcceptedTermsAndConditions = _a[1];
    var _b = React.useState(false), acceptedPrivacyPolicy = _b[0], setAcceptedPrivacyPolicy = _b[1];
    var _c = React.useState(false), acceptedMarketingConsent = _c[0], setAcceptedMarketingConsent = _c[1];
    React.useEffect(function () {
        props.hasAcceptedTerms(acceptedTermsAndConditions && acceptedPrivacyPolicy)();
    }, [acceptedTermsAndConditions, acceptedPrivacyPolicy]);
    React.useEffect(function () { return void props.acceptMarketingConsent(acceptedMarketingConsent)(); }, [acceptedMarketingConsent]);
    return (React.createElement(sok_ui_1.Tabs, { className: 'first-login-view-tabsbar', activeIndex: 0 },
        React.createElement("div", { key: 'tab' },
            React.createElement("label", null, (0, translation_1.getLocalization)('firstTimeLogin/step3/consents'))),
        React.createElement("div", { key: 'tab-content', className: 'tab-content' },
            React.createElement(Consents_1.Consents, { canAcceptMarketingConsent: true, canAcceptPrivacyPolicy: true, canAcceptTermsAndConditions: true, hasAcceptedMarketingConsent: acceptedMarketingConsent, hasAcceptedPrivacyPolicy: acceptedPrivacyPolicy, hasAcceptedTermsAndConditions: acceptedTermsAndConditions, onAcceptMarketingConsentChange: setAcceptedMarketingConsent, onAcceptTermsAndConditionsChange: setAcceptedTermsAndConditions, onAcceptPrivacyPolicyChange: setAcceptedPrivacyPolicy }))));
};
exports.StepConsents = StepConsents;
